import React from 'react';
import {
	BookingWizardTab,
	SidebarStatus,
	VisibilityStatus,
} from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizard';
import { FerryBookingTimerWrap } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/Components/FerryBookingTimerWrap';
import { FerryProgressBarStyledSection } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/ProgressBar/FerryProgressBarStyledSection';
import If from 'Views/Components/If/If';

export interface FerryBookingWizardProgressBarProps {
	tabs: BookingWizardTab[];
	progressBarClass: string;
	onClickTab: (tab: BookingWizardTab) => void;
	currentTabIndex: number;
	isMobileBookingWizard: boolean;
	onTimerExpiry: () => void;
	ticketsPageUrl: string;
	disabled: boolean;
	forEventBooking: boolean;
}

export function FerryBookingWizardProgressBar({
	onTimerExpiry,
	progressBarClass,
	onClickTab,
	tabs,
	currentTabIndex,
	isMobileBookingWizard,
	ticketsPageUrl,
	disabled,
	forEventBooking,
}: FerryBookingWizardProgressBarProps) {
	const completedTabs = tabs.slice(0, currentTabIndex + 1).filter(tab => tab.visibility === VisibilityStatus.VISIBLE);
	const incompleteTabs = tabs.slice(currentTabIndex + 1).filter(tab => tab.visibility === VisibilityStatus.VISIBLE);
	const sidebarExists: boolean = tabs[currentTabIndex].sidebarStatus !== SidebarStatus.NO_SIDEBAR;

	const currentTab = tabs[currentTabIndex];

	return (
		<div className="booking-wizard-progress-bar-container">
			<ol className={progressBarClass}>
				<FerryProgressBarStyledSection
					completedSection
					isLastValidStep={completedTabs.length === tabs.length}
					onClickTab={onClickTab}
					sidebarExists={sidebarExists}
					tabs={completedTabs}
					isMobile={isMobileBookingWizard}
					disabled={disabled}
					currentTab={currentTab}
				/>
				<FerryProgressBarStyledSection
					completedSection={false}
					isLastValidStep={false}
					// This styled section is for tabs which we haven't reached yet. As a result, the buttons will be
					// disabled, so we don't need to do anything when the tabs are clicked
					sidebarExists={sidebarExists}
					tabs={incompleteTabs}
					isMobile={isMobileBookingWizard}
					disabled={disabled}
					currentTab={currentTab}
				/>
			</ol>
			<If condition={isMobileBookingWizard}>
				<FerryBookingTimerWrap
					onTimerExpiry={onTimerExpiry}
					isIpad={isMobileBookingWizard}
					ticketsPageUrl={ticketsPageUrl}
					forEventBooking={forEventBooking}
				/>
			</If>
		</div>
	);
}
